import React from 'react';
import PropTypes from 'prop-types';
import {
  TopBarContainer,
  TopBar,
  TopBarMenu,
  TopBarMenuTab,
  MenuTabContent
} from '../../styled-components/TopBar';
import Settings from '../../settings';

export const PUBLISH_TABS = {
  facebook: 'Facebook',
  twitter: 'Twitter',
  instagram: 'Instagram'
};

class Tabs extends React.PureComponent {
  render() {
    const { activeTab, completedTabs, onSelectTab } = this.props;
    return (
      <TopBarContainer>
        <TopBar style={{ backgroundColor: 'transparent' }}>
          <div style={{ width: 'calc(100% - 12px)' }}>
            <TopBarMenu>
              {Object.keys(PUBLISH_TABS).map(key => {
                const value = PUBLISH_TABS[key];
                if (value === PUBLISH_TABS.twitter && !Settings.socialMediaIntegrations.twitter) {
                  return null;
                }

                if (value === PUBLISH_TABS.facebook && !Settings.socialMediaIntegrations.facebook) {
                  return null;
                }

                if (
                  value === PUBLISH_TABS.instagram &&
                  !Settings.socialMediaIntegrations.instagram
                ) {
                  return null;
                }
                const completed = completedTabs.some(t => t === value);
                return (
                  <TopBarMenuTab
                    style={{ height: '24px', width: '20%' }}
                    key={value}
                    active={activeTab === value}
                    onClick={() => onSelectTab(value)}
                  >
                    <MenuTabContent>
                      {value} {completed && <img src="images/ok.png" />}
                    </MenuTabContent>
                  </TopBarMenuTab>
                );
              })}
            </TopBarMenu>
          </div>
        </TopBar>
      </TopBarContainer>
    );
  }
}

Tabs.propTypes = {
  activeTab: PropTypes.string.isRequired,
  completedTabs: PropTypes.arrayOf(PropTypes.string).isRequired,
  onSelectTab: PropTypes.func.isRequired
};

export default Tabs;



// WEBPACK FOOTER //
// ./app/components/PublishingDialog/Tabs.js